import type { Form, FormSuccess, Project } from '../types/data';
import { DEFAULT_URL } from './constants';

export interface FetchProjectParams {
  token: string;
  resource: string;
  url?: string;
}

export async function fetchProject(params: FetchProjectParams): Promise<Project> {
  const _url = params.url || DEFAULT_URL;

  // TODO: Add server side support
  const response = await fetch(`${_url}/api/v1/project/${params.token}/resource/${params.resource}`);
  const json = await response.json();

  if (json.ok) {
    return json.data;
  }

  const message = json.error.issues.length > 0 ? json.error.issues[0].message : json.error.message;

  console.error(message);
}

export interface CollectParams {
  token: string;
  resource: string;
  reactionId: string;
  url?: string;
  count: number;
}

export async function collectReaction(params: CollectParams) {
  const _url = params.url || DEFAULT_URL;

  // TODO: Add server side support
  const response = await fetch(`${_url}/api/v1/project/${params.token}/resource/${params.resource}/collect/${params.reactionId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ count: params.count }),
  });
  const json = await response.json();

  if (json.ok) {
    return json.data;
  }

  const message = json.error.issues.length > 0 ? json.error.issues[0].message : json.error.message;

  console.error(message);
}

export interface FetchReactionFormParams {
  token: string;
  reactionId: string;
  url?: string;
}

export async function fetchForm(params: FetchReactionFormParams): Promise<Form> {
  const _url = params.url || DEFAULT_URL;

  // TODO: Add server side support
  const response = await fetch(`${_url}/api/v1/project/${params.token}/reaction/${params.reactionId}`);

  if ([204, 404].includes(response.status)) {
    throw new Error('Cannot find form for reaction');
  }

  const json = await response.json();

  if (json.ok) {
    if (json.data.fields.length === 0) {
      throw new Error('Cannot find form for reaction');
    }

    return json.data;
  }

  const message = json.error.issues?.length > 0 ? json.error.issues[0].message : json.error.message;

  console.error(message);
}

export interface SaveParams {
  token: string;
  reactionId: string;
  url?: string;
  values: Record<string, any>;
  resources: string[];
  count?: number;
}

export async function saveResponse(params: SaveParams): Promise<FormSuccess> {
  const _url = params.url || DEFAULT_URL;

  // TODO: Add server side support
  const response = await fetch(`${_url}/api/v1/project/${params.token}/reaction/${params.reactionId}/save`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ values: params.values, resources: params.resources }),
  });
  const json = await response.json();

  if (json.ok) {
    return json.data;
  }

  const message = json.error.issues.length > 0 ? json.error.issues[0].message : json.error.message;

  console.error(message);
}
